/* eslint-disable import/prefer-default-export */

// this house tours link contains pinterest data attrs that we must remove to
// prevent unintended embedding of a pinterest board.
export const PINTEREST_HOUSE_TOURS_REGEXP = /<a data-pin-do="embedBoard".+>House Tours on Pinterest<\/a>/;

/**
 * removes the data attrs added by the at-house-tour.jst.hbs template in ATCMS.
 *
 * https://github.com/apartmenttherapy/atcms/blob/master/app/assets/javascripts/admin/cms/templates/post-templates/at-house-tour.jst.hbs#L57
 *
 * NOTE: this function mutates the passed tag.
 *
 * @export
 * @param {Object} tag a tag/link that contains erroneous data atts.
 */
export function fixPinterestHouseToursLink(tag) {
  if (tag.tagName.toLowerCase() !== 'a') {
    return;
  }

  const attrsToRemove = [
    'data-pin-do',
    'data-pin-scale-width',
    'data-pin-scale-height',
    'data-pin-board-width'
  ];

  attrsToRemove.forEach(attr => {
    tag.removeAttribute(attr);
  });
}
